import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { CounsellorService } from "../services/counsellor.service";


@Injectable()
export class CounsellorProfileResolve implements Resolve<any> {

    constructor(private counsellorService: CounsellorService) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let mbNumber = route.params['mbno']
        if (mbNumber == null) {
            return null;
        }

        return new Promise<any>((resolve, reject) => {
            this.counsellorService.getCounsellorProfile(mbNumber).subscribe(
                (data) => {
                    resolve(data);
                });
        }).then(function (data) {
            return data;
            });

    }

}
